import type { ReferentialAxis } from '@/core/domain/referential/axis/ReferentialAxis.ts'
import type { IReferentialRepository } from '@/core/domain/referential/IReferentialRepository.ts'
import type { IReferentialUrlOptions } from '@/core/domain/referential/IReferentialUrlOptions.ts'
import { ReferentialUrlOptions } from '@/core/domain/referential/ReferentialUrlOptions.ts'

export class FetchAxisByIdUseCase {
  private referentialRepository: IReferentialRepository

  constructor(referentialRepository: IReferentialRepository) {
    this.referentialRepository = referentialRepository
  }

  async execute(id: number, URLOptions: IReferentialUrlOptions): Promise<ReferentialAxis> {
    return await this.referentialRepository.fetchById(id)
  }
}
